import React from "react";
import "../../css/custom.css";
import "../../css/style.css";
import { useInventoryProductContext } from "../../../Context/Cache/InventoryProductContext";
import { FilterDropdown } from "../../ExternalComponent";
 
const HeaderFilter = () => {
  const {
    handleCheckboxChange,
    brandData,
    selectedBrands,
    setSelectedBrands,
    categoryData,
    subCategoryData,
    itemCategoryCodeData,
    selectedCategories,
    setSelectedCategories,
    selectedSubCategories,
    setSelectedSubCategories,
    selectedItemCategoryCodes,
    setSelectedItemCategoryCodes,
  } = useInventoryProductContext();
 
return (
    <div className="main-header-wrapper background-parent">
      <div className="container">
        <div className="row flex justify-center">
          <div className="col-lg-12 flex justify-center">
            <div className="main-header-inner h-0.5">
              <div className="main-menu">
               
                <nav id="mobile-menu ">
                  <ul className="">
                    {/* <FilterDropdown
                      label="Category"
                      data={categoryData}
                      selectedItems={selectedCategories}
                      setSelectedItems={setSelectedCategories}
                      handleCheckboxChange={handleCheckboxChange}
                    />
                    <FilterDropdown
                      label="Sub Category"  
                      data={subCategoryData}
                      selectedItems={selectedSubCategories}
                      setSelectedItems={setSelectedSubCategories}
                      handleCheckboxChange={handleCheckboxChange}
                    />
                    <FilterDropdown
                      label="Brand"
                      data={brandData}
                      selectedItems={selectedBrands}
                      setSelectedItems={setSelectedBrands}
                      handleCheckboxChange={handleCheckboxChange}
                    />
                    <FilterDropdown
                      label="Item Category Code"
                      data={itemCategoryCodeData}
                      selectedItems={selectedItemCategoryCodes}
                      setSelectedItems={setSelectedItemCategoryCodes}
                      handleCheckboxChange={handleCheckboxChange}
                    /> */}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          <div className="col-12 d-block d-lg-none">
            <div className="mobile-menu"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default HeaderFilter;